import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

export default {
  getHeaders () {
    const user = JSON.parse(sessionStorage.getItem('user'))

    return {
      id: user ? user.login : ''
    }
  },

  async searchEntreprise (credentials) {
    return axios.post('/adminrechercheentreprise/search', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async searchEntrepriseGestDepenses (credentials) {
    return axios.post('/adminrechercheentreprise/entrepriseGestDepenses', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async searchOperations (credentials) {
    return axios.post('/entreprise/gestionnaireoperations', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async searchOperationsAdmin (credentials) {
    return axios.post('/administration/searchOperationsAdmin', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async searchRapports (credentials) {
    return axios.post('/entreprise/gestionnairerapport', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async downloadRapportFile (credentials) {
    return axios.post('/entreprise/downloadrapportfile', credentials, { responseType: 'blob', headers: this.getHeaders(), withCredentials: true })
  },

  async getParcCartes (credentials) {
    return axios.post('/entreprise/gestionnaireparcdecartes', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getInfosPorteur (credentials) {
    return axios.post('/entreprise/updinfoporteurs', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getFileOperationsPorteur (credentials, responseTypeFile) {
    return axios.post('/entreprise/gestionnairetelechargement', credentials, { responseType: responseTypeFile, headers: this.getHeaders(), withCredentials: true })
  },

  async getRelevesOperations (credentials) {
    return axios.post('/entreprise/getrelevesoperations', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async downloadRelevesPorteurs (credentials) {
    return axios.post('/entreprise/downloadrelevesporteur', credentials, { responseType: 'blob', headers: this.getHeaders(), withCredentials: true })
  }
}
